import { useGetPrimaryAddressQuery } from "types/generated/operations";
import Loader from "uicomponents/Loader";
import ErrorPage from "uicomponents/Error";
import { getProspectUuid } from "utils/idHelpers";
import PrimaryBusinessAddress from "./PrimaryBusinessAddress";
import { getAppType } from "utils/helper";

interface IPrimaryBusinessAddressProps {
  setNextStep: () => void;
  disableNextStep: boolean;
}

const PrimaryBusinessAddressModel = (props: IPrimaryBusinessAddressProps) => {
  const { data, error, loading } = useGetPrimaryAddressQuery({
    variables: { uuid: getProspectUuid(), appType: getAppType() },
    fetchPolicy: "no-cache",
  });
  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <ErrorPage />;
  }
  return (
    <PrimaryBusinessAddress
      data={data?.prospect}
      setNextStep={props.setNextStep}
      disableNextStep={props.disableNextStep}
    />
  );
};
export default PrimaryBusinessAddressModel;
